import React from "react";
import styled from "styled-components";
import { Colors } from "../../config";

const Modal = ({ children }) => {
  return <ModalContainer>{children}</ModalContainer>;
};

const ModalContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: ${Colors.shark + "99"};
  height: 100vh;
  width: 100vw;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Modal;
